/**
 *
 * Asynchronously loads the component for VisitScheduled
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "ongoing-negotiation" */ './index'),
  loading: () => null,
});
